import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const UserProfileRedirect = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId } = useParams<{ userId: string }>();

  useEffect(() => {
    if (userId) {
      navigate(`/profile/${encodeURIComponent(userId)}`, { replace: true });
    } else {
      navigate('/profile', { replace: true });
    }
  }, [userId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">{t('nav.redirectingToProfile')}</p>
      </div>
    </div>
  );
};

export default UserProfileRedirect;
